import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Icon as TIcon } from '../../types/shared/Icon';

import './ContactInformation.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Row, Col, Section, Icon } from '../../importCL';
interface IContactInformationProps extends MappedComponentProperties {
    version?: 'phoneEmailVersion' | 'helpCenter';
    phoneIcon?: TIcon;
    mediaIcon?: TIcon;
    helpIcon?: TIcon;
    phone?: string;
    phoneDescription?: string;
    email?: string;
    helpRte?: string;
}

export const ContactInformationEditConfig = {
    emptyLabel: 'ContactInformation',
    isEmpty: (props: PropsWithChildren<IContactInformationProps>) => {
        return !props || !props.version;
    },
};

const ContactInformation = (props: PropsWithChildren<IContactInformationProps>): JSX.Element => {

    const phone = (props.phoneIcon || props.phone);
    const email = (props.mediaIcon || props.email);
    const emailLength = props.email ? props.email.length : 0;

    return (
        <Section id='contact-information' className='ContactInformation !py-0'>
            {props.version === 'helpCenter' ?
                <Row className='ContactInformation__helpCenter !m-0 justify-center'>
                    <Col className='flex justify-center md:!block md:!text-center'>
                        <Icon loading='lazy' size='badge' src={props.helpIcon?.iconPath}
                            className='m-4'
                            alt={props.helpIcon?.iconAltText} />
                        <div className='my-auto mx-0'>
                            {props.helpRte && transformHTMLParserLinks(props.helpRte)}
                        </div>
                    </Col>
                </Row>
                :
                <Row>
                    {phone &&
                        <Col xs={12} md={email ? 6 : 12} 
                            className={email ? 'flex flex-wrap justify-center items-center md:text-center md:block md:mb-4'
                                : 'flex justify-center md:!block md:!text-center'}>
                            <Icon loading='lazy' size='badge' src={props.phoneIcon?.iconPath}
                                className='m-4'
                                alt={props.phoneIcon?.iconAltText} />
                            <div className='self-center'>
                                <p className='mb-2'>
                                    <strong>{props.phone}</strong>
                                </p>
                                <span className='ContactInformation__span'>{transformHTMLParserLinks(props.phoneDescription ?? '')}</span>
                            </div>
                        </Col>}
                    {email &&
                        <Col xs={12} md={phone ? 6 : 12}
                            className={phone ? 'flex flex-wrap justify-center items-center md:text-center md:block md:mb-4'
                                : emailLength >= 21 ? 'flex justify-center flex-wrap md:items-center'
                                    : 'flex justify-center md:!block md:!text-center'}>
                            <Icon loading='lazy' size='badge' src={props.mediaIcon?.iconPath}
                                className={(phone || emailLength >= 21) ? 'm-4' : 'ContactInformation__Icon--overlap m-4'}
                                alt={props.mediaIcon?.iconAltText} />
                            <div className='my-auto mx-0'>
                                <a className='LINK self-center' href={`mailto:${props.email}`}>{props.email}</a>
                            </div>
                        </Col>
                    }
                </Row>
            }
        </Section>
    );
};

export default ContactInformation;

